var _circle, _circle2, _circle3, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconCategories = function SvgIconCategories(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 19.5,
    r: 0.5,
    fill: "#000"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 25.5,
    r: 0.5,
    fill: "#000"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 31.5,
    r: 0.5,
    fill: "#000"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M20.5 25.5h11M20.5 19.5h11.188M20.5 31.5h11.188"
  })));
};
export { SvgIconCategories as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDgiIGhlaWdodD0iNDgiIHZpZXdCb3g9IjAgMCA0OCA0OCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMTUuNSIgY3k9IjE5LjUiIHI9IjAuNSIgZmlsbD0iYmxhY2siLz4KPGNpcmNsZSBjeD0iMTUuNSIgY3k9IjI1LjUiIHI9IjAuNSIgZmlsbD0iYmxhY2siLz4KPGNpcmNsZSBjeD0iMTUuNSIgY3k9IjMxLjUiIHI9IjAuNSIgZmlsbD0iYmxhY2siLz4KPGxpbmUgeDE9IjIwLjUiIHkxPSIyNS41IiB4Mj0iMzEuNSIgeTI9IjI1LjUiIHN0cm9rZT0iYmxhY2siIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8bGluZSB4MT0iMjAuNSIgeTE9IjE5LjUiIHgyPSIzMS42ODc1IiB5Mj0iMTkuNSIgc3Ryb2tlPSJibGFjayIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxsaW5lIHgxPSIyMC41IiB5MT0iMzEuNSIgeDI9IjMxLjY4NzUiIHkyPSIzMS41IiBzdHJva2U9ImJsYWNrIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg==";